export default __webpack_public_path__ + "static/media/support.aae2c423.svg";